export default __webpack_public_path__ + "static/media/logo-horizontal.8e510282.svg";